import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Alert, Card, CardBody, Container, Form, FormFeedback, Label, Input, UncontrolledAlert } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { get, post } from "../../Services/RestAPIService"

// Redux
import { connect, useDispatch } from "react-redux";

// import { withRouter, Link } from "react-router-dom"
import { Link } from 'react-router-dom';
import withRouter from 'components/Common/withRouter';
import { useParams, useNavigate } from "react-router-dom";
// action
import { userForgetPassword } from "../../store/actions";

// import images
import logoSm from "../../assets/images/logo-sm.png";

const ConfirmPassword = () => {
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const { token } = useParams();
    const [alert, setAlert] = useState({
        color: "",
        message: "",
        visible: false,
        strongM: ""
    });


    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            password: '',
            confirmPassword: ''
        },
        validationSchema: Yup.object({
            password: Yup.string().required("Please Enter Your Password").min(8, "Password must be at least 8 characters"),
            confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
        }),
        onSubmit: async (values, { resetForm }) => {



            console.log("Check", values);
            try {
                const response = await post(`v1/reset-password/${token}`, values, {
                    headers: { 'Content-Type': 'application/json' },
                    validateStatus: false
                });
                console.log(response, "response");

                if (response.status <= 399) {
                    if (response.data) {

                        console.log("Success: " + response.data);
                        navigate('/login');


                        setAlert({
                            color: "success",
                            visible: true,
                            message: "Password is Changed",
                            strongM: "Success!"
                        });
                        resetForm()
                        setTimeout(() => {
                            setAlert({ visible: false });
                        }, 6000);

                    }


                } else {


                    // ERROR


                    const errorMessage = response.data?.message || "An error occured";
                    setAlert({
                        color: "danger",
                        visible: true,
                        message: errorMessage,
                        strongM: "Error!"
                    });
                    setTimeout(() => {
                        setAlert({ visible: false });
                    }, 3000);

                }
            } catch (error) {
                setAlert({
                    color: "danger",
                    visible: true,
                    message: "An error occured",
                    strongM: "Error!"
                });
                setTimeout(() => {
                    setAlert({ visible: false });
                }, 3000);

                console.log(error, "catch (error) {");
            }
        }



    });

    const shouldShowError = useMemo(() => {
        return validation.touched.password && validation.errors.password;
    }, [validation.touched.password, validation.errors.password]);

    document.title = "Forget Password | Llosana";
    return (
        <React.Fragment>
            {alert.visible && <UncontrolledAlert className="Alert_Additions_Log" color={`${alert.color || "warning"}`} role="alert">
                {alert?.message || "Welcome"}
            </UncontrolledAlert>}

            <div className="home-btn d-none d-sm-block">
                <Link to="/" className="text-dark">
                    <i className="fas fa-home h2"></i>
                </Link>
            </div>
            <div className="account-pages my-5 pt-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={4}>
                            <Card className="overflow-hidden">
                                <div className="bg-primary">

                                <div className="text-primary text-center p-4">
                                    <h5 className="text-white font-size-20 p-2">Password Reset</h5>
                                    <Link to="/index" className="logo logo-admin">
                                        <img src={logoSm} height="24" alt="logo" />
                                    </Link>
                                </div>
                                </div>

                                <CardBody className="p-4">



                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}
                                        className="mt-4">

                                        <div className="mb-3">
                                            <Label className="form-label" for="password">Password</Label>
                                            <Input
                                                name="password"
                                                className="form-control"
                                                placeholder="Enter password"
                                                type="password"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.password || ""}
                                                invalid={shouldShowError}
                                            />
                                            {shouldShowError && (
                                                <FormFeedback type="invalid">
                                                    <div>{validation.errors.password}</div>
                                                </FormFeedback>
                                            )}
                                        </div>

                                        <div className="mb-3">
                                            <Label className="form-label" for="confirmPassword">Confirm Password</Label>
                                            <Input
                                                name="confirmPassword"
                                                className="form-control"
                                                placeholder="Enter confirm password"
                                                type="password"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.confirmPassword || ""}
                                                invalid={validation.touched.confirmPassword && validation.errors.confirmPassword}
                                            />
                                            {validation.touched.confirmPassword && validation.errors.confirmPassword && (
                                                <FormFeedback type="invalid">
                                                    <div>{validation.errors.confirmPassword}</div>
                                                </FormFeedback>
                                            )}
                                        </div>



                                        <div className="row  mb-0">
                                            <div className="col-12 text-end">
                                                <button className="btn btn-primary w-md waves-effect waves-light" type="submit">Reset</button>
                                            </div>
                                        </div>

                                    </Form>
                                </CardBody>
                                
                            </Card>
                            <div className="mt-5 text-center">
                                <p>Remember It ? <Link to="/login" className="fw-medium text-primary"> Sign In here </Link> </p>
                                {/*<p>
                  © {new Date().getFullYear()} Veltrix. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Themesbrand
                </p>*/}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};


ConfirmPassword.propTypes = {
    forgetError: PropTypes.any,
    forgetSuccessMsg: PropTypes.any,
    history: PropTypes.object,
    userForgetPassword: PropTypes.func
};

const mapStatetoProps = state => {
    const { forgetError, forgetSuccessMsg } = state.ForgetPassword;
    return { forgetError, forgetSuccessMsg };
};

export default withRouter(
    connect(mapStatetoProps, { userForgetPassword })(ConfirmPassword)
);